import { createApi } from '@reduxjs/toolkit/query/react'
import { createNeighborhoodAwareBaseQuery } from '../../../Utils/baseQuery'

export const feedbackApiService = createApi({
  reducerPath: 'feedbackApi',
  baseQuery: createNeighborhoodAwareBaseQuery('/feedback/'),
  endpoints: (builder) => ({
    getFeedback: builder.query({
      query: (args) => ({
        url: args?.id ? `get/${args?.id}` : "get",
        method: "GET",
        params: args?.id ? {} : args
      }),
      keepUnusedDataFor: 0
    })
  })
})

export const {
  useGetFeedbackQuery
} = feedbackApiService